import * as React from 'react';


import Box from '@mui/material/Box'


import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Card from'@mui/material/Card'
import CardContent from'@mui/material/CardContent'
import CardHeader from'@mui/material/CardHeader'
import { CharismaDocumentsApi } from '../api/documents/CharismaDocumentsApi.tsx';
import CharismaUserDocumentForm from '../user/userDocumentForm.tsx';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';




export default function CharismaStudentDocumentsList(){
    
    const [documents, setDocuments] = React.useState([]);
    const [create, setCreate] = React.useState(false);
    const [currentId, setCurrentId] = React.useState(null);
    const [currentType, setCurrentType] = React.useState(null);
    const [deleteDocument, setDeleteDocument] = React.useState(false);
    const [selectedDocuments, setSelectedDocuments] = React.useState([]);
    
    React.useEffect(()=>{
        const lResponse = CharismaDocumentsApi.ListStudentDocument();
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.documents !== null){
                    setDocuments(value.documents);
                }
                
            }
        }).catch((error)=>{
            
        })
        setSelectedDocuments([]);
    }, [])
    
    
    function handleCancel(){
        setCreate(false);
    }

    
    
    function handleSelectedDocument(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = selectedDocuments.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(selectedDocuments, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(selectedDocuments.slice(1));
            }
            else if(lIndex === selectedDocuments.length - 1){
                lNewSelected = lNewSelected.concat(selectedDocuments.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(selectedDocuments.slice(0, lIndex), selectedDocuments.slice(lIndex + 1),);
            }
        }
        setSelectedDocuments(lNewSelected);
    }
    
    
    function handleSubmit(pType : string){
        const lResponse = CharismaDocumentsApi.CreateStudentDocument(lTrainingId, pType);
        lResponse.then((value)=>{
            if(value.error === 0){
                setCreate(false);
                if(value.document !== null){
                    let lUserDocuments = documents.concat(value.document);
                    setDocuments(lUserDocuments);
                }
                
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    }
    
    function handleUpdate(pType : string, pId : number){
        const lResponse = CharismaDocumentsApi.UpdateStudentDocument(pType, pId);
        lResponse.then((value)=>{
            if(value.error === 0){ 
                setCurrentId(null);
                setCurrentType(null);
                if(value.document !== null){
                    let lDocument = value.document;
                    let lDocumentsList = documents;
                    for(let lIndex = 0; lIndex < lDocumentsList.length; lIndex++){
                        if(lDocument.id === lDocumentsList[lIndex].id){
                            lDocumentsList[lIndex].type = lDocument.type;
                            break;
                        }
                    }
                    setDocuments(lDocumentsList);
                    
                }
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    }
    
    function handleCancelUpdate(){
        setCurrentId(null);
        setCurrentType(null);
    }
    
    function handleEdit(pId : number, pType : string){
        setCurrentId(pId);
        setCurrentType(pType);
    }
    
    function handleDelete(){
        const lResponse = CharismaDocumentsApi.DeleteStudentDocument(selectedDocuments);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.ids !== null){
                    let lDocuments = documents.filter((document)=>(value.ids.indexOf(document.id) === -1));
                    setDocuments(lDocuments);
                    setSelectedDocuments([]);
                }
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        }) 
    }
    
    return(
        
        <Box>
            <Card>
                <CardHeader
                    title={"Documents d'incription"}
                    action={
                        <div>
                        <IconButton onClick={()=>setCreate(true)}>
                            <AddIcon/>
                        </IconButton>
                        {selectedDocuments.length > 0 ?
                            <IconButton onClick={()=>setDeleteDocument(true)}>
                                <DeleteIcon/>
                            </IconButton>  
                            :
                            null
                        } 
                        </div>
                    } 
                />
                <CardContent>
                    <Table>                               
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                </TableCell>
                                <TableCell>
                                    Type de document
                                </TableCell>
                                <TableCell padding="checkbox">
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {
                            documents.map((document)=>(
                                <TableRow>
                                    <TableCell>
                                        <Checkbox
                                            checked={selectedDocuments.indexOf(document.id) !== -1}
                                            onClick={(event)=>handleSelectedDocument(event, document.id)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        {document.type}
                                    </TableCell>
                                    <TableCell padding="checkbox">
                                        <IconButton
                                            onClick={()=>handleEdit(document.id, document.type)}
                                        >
                                            <EditIcon/>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>     
                            ))
                        }
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
               
            {create ?
                <CharismaUserDocumentForm
                    title={"Ajout d'un type de document"}
                    handleSubmit={handleSubmit}
                    handleCancel={handleCancel}
                />
                :
                null    
            }    
            {
                currentId !== null ?
                <CharismaUserDocumentForm
                    title={"Modification"}
                    type = {currentType}
                    id={currentId}
                    handleSubmit={handleUpdate}
                    handleCancel={handleCancelUpdate}
                />
                :
                null
            }
            <Dialog
                open={deleteDocument}
            >
                <DialogTitle>Suppression de Type de document</DialogTitle>
                <DialogContent>
                    <div>
                        <Typography>Etes-vous sûr de vouloir supprimer définitivement les type sélectionnés?</Typography>
                        <Alert severity='warning'>Cette action sera définitive</Alert>
                    </div>
                    
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteDocument(false)}>
                        Annuler
                    </Button>
                    <Button onClick={()=>{handleDelete();setDeleteDocument(false)}}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog> 
                  
        </Box>      
    );
    
    
}